import {
  ALL_APP_IDS,
  ALL_APPS,
  ALL_VIEW_IDS,
  ALL_VIEWS,
} from 'constants/appConstants';
import PermissionsRouteWrapper from 'views/pages/components/PermissionsRouteWrapper';
import Loadable from 'ui-component/Loadable';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { Redirect } from 'react-router6-redirect';
import FullHeightMainCardWrapper from 'layout/MainLayout/FullHeightMainCardWrapper';
import Kits from 'views/kitting/Kits';
import Kit from 'views/kitting/Kit/KitRequestWrapper';
import { ORG_PREFERENCES_TABS } from 'views/org/OrgPreferences';

const InventoryAddresses = Loadable(
  lazy(() => import('views/kitting/Addresses'))
);
const WarehouseShipments = Loadable(
  lazy(() => import('views/kitting/WarehouseShipments'))
);
const WarehouseShipment = Loadable(
  lazy(() => import('views/kitting/WarehouseShipment'))
);

export const KittingRoutes = [
  {
    path: `${ALL_VIEWS.SHIPMENTS.deprecatedPath}`,
    element: <Redirect to={ALL_VIEWS.SHIPMENTS.path ?? ''} />,
  },
  {
    path: `${ALL_APPS.KITTING.deprecatedPath}`,
    element: <Redirect to={ALL_APPS.KITTING.path ?? ''} />,
  },
  {
    path: `${ALL_VIEWS.SHIPMENTS.path}`,
    element: <Redirect to={ALL_APPS.KITTING.path ?? ''} />,
  },
  {
    path: `${ALL_APPS.KITTING.path}`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APP_IDS.KITTING,
          view: ALL_VIEW_IDS.WAREHOUSE_SHIPMENTS,
        }}
      >
        <FullHeightMainCardWrapper>
          <WarehouseShipments />
        </FullHeightMainCardWrapper>
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_VIEWS.SHIPMENTS.deprecatedPath}/:shipmentId`,
    element: (
      <Redirect to={`${ALL_VIEWS.WAREHOUSE_SHIPMENTS.path}/:shipmentId`} />
    ),
  },
  {
    path: `${ALL_VIEWS.SHIPMENTS.path}/:shipmentId`,
    element: (
      <Redirect to={`${ALL_VIEWS.WAREHOUSE_SHIPMENTS.path}/:shipmentId`} />
    ),
  },
  {
    path: `${ALL_VIEWS.ADDRESSES.deprecatedPath}`,
    element: <Redirect to={ALL_VIEWS.ADDRESSES.path ?? ''} />,
  },
  {
    path: `${ALL_VIEWS.ADDRESSES.path}`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APPS.KITTING.id,
          view: ALL_VIEW_IDS.ADDRESSES,
        }}
      >
        <InventoryAddresses />
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_APPS.KITTING.views?.KITTING_PREFERENCES?.path}`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APPS.KITTING.id,
          view: ALL_VIEW_IDS.KITTING_PREFERENCES,
        }}
      >
        <Navigate
          to={`${ALL_APPS.ORG_SETTINGS.path}?tab=${ORG_PREFERENCES_TABS.SHIPPING}`}
          replace
        />
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: ALL_VIEWS.KITS.path as string,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APP_IDS.KITTING,
          view: ALL_VIEW_IDS.KITS,
        }}
      >
        <FullHeightMainCardWrapper>
          <Kits />
        </FullHeightMainCardWrapper>
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_VIEWS.KITS.path}/:kitRequestId`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APP_IDS.KITTING,
          view: ALL_VIEW_IDS.KITS,
        }}
      >
        <Kit />
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_VIEWS.WAREHOUSE_SHIPMENTS.path}`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APP_IDS.KITTING,
          view: ALL_VIEW_IDS.WAREHOUSE_SHIPMENTS,
        }}
      >
        <FullHeightMainCardWrapper>
          <WarehouseShipments />
        </FullHeightMainCardWrapper>
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_VIEWS.WAREHOUSE_SHIPMENTS.path}/:warehouseShipmentId`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APP_IDS.KITTING,
          view: ALL_VIEW_IDS.WAREHOUSE_SHIPMENTS,
        }}
      >
        <WarehouseShipment />
      </PermissionsRouteWrapper>
    ),
  },
];
